// extracted by mini-css-extract-plugin
module.exports = {"seoSearchLink":"style-module--seoSearchLink--3xMxI","seoSearchContainer":"style-module--seoSearchContainer--Qw_si","searches":"style-module--searches--1phRI"};